import { Dialog } from "layout";
import React, { useState } from "react";
import Body from "./Body";

const BizContext = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <Dialog show={showForm} onClose={false} maxWidth="xs">
      <Body {...{ setShowForm }} />
    </Dialog>
  );
};

export default BizContext;
